import * as actionTypes from "../actionTypes";

const initialState = {
    operatorData: [],
    operatorImageData: [],
};

const operatorImageReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_OPERATOR: {
            return {
                ...state,
                operatorData: payload,
            };
        }
        case actionTypes.SET_OPERATOR_IMAGES: {
            return {
                ...state,
                operatorImageData: payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default operatorImageReducer;
